import { render } from "./DatePicker.vue?vue&type=template&id=455e65b4&scoped=true&ts=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=455e65b4&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455e65b4"]])

export default __exports__